import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, CircularProgress, Collapse, Grid, IconButton, ListItem, ListItemText, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { MdiIcon, Table, useSnackbar } from '@components';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { mdiChevronUp, mdiContentSave, mdiPlus } from '@mdi/js';
import moment from 'moment';
import { useModal } from 'mui-modal-provider';
const PessoasAssociadas = ({ $state, CrmService, user }) => {
    const [dataEmpresaAssociada, setDataEmpresaAssociada] = useState(); // dados dos clientes
    const [loadingEmpresaAssociada, setLoadingEmpresaAssociada] = useState(true);
    const [refetchingEmpresaAssociada, setRefetchingEmpresaAssociada] = useState(false);
    const [filterEmpresaAssociada, setFilterEmpresaAssociada] = useState([]); // filtros a aplicar na tabela
    const [sortEmpresaAssociada, setSortEmpresaAssociada] = useState([]); // ordenação da tabela
    const [optionsEmpresaAssociada, setOptionsEmpresaAssociada] = useState({
        filter: [], // exemplo -> [{name: 'nome', type: 'TEXT'}, {name: 'ultimoContacto', type: 'DATE', options: {format: 'YYYY-MM-DD'}}, ...]
        sort: [] // exemplo -> ['id', 'nome', 'ultimoContacto', 'contactoTelefonico', 'nif', 'email', 'morada', 'localidade']
    });
    const [paginationEmpresaAssociada, setPaginationEmpresaAssociada] = useState({
        pageIndex: 0,
        pageSize: 5
    });
    const [expand, setExpand] = useState(false);
    const [value, setValue] = useState(null);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const { showSnackbar } = useSnackbar();
    const validationSchema = yup.object().shape({
        idCoreContactoAssociado: yup
            .number()
            .required('Este campo é obrigatório')
            .test('exists', 'O contacto já se encontra associado', async (value) => {
            if (!value)
                return true;
            const d = await CrmService.existsInContactoAssociado(value, user.id);
            return d.count === 0;
        })
    });
    const { showModal } = useModal();
    const formik = useFormik({
        initialValues: {},
        enableReinitialize: true,
        validateOnMount: false,
        validationSchema: validationSchema,
        validateOnChange: false,
        onSubmit: async (values) => {
            submit(values);
        }
    });
    const submit = async (val) => {
        val.idCoreContacto = user.id;
        val.dataRegisto = moment().format();
        try {
            await CrmService.createAssociacaoContacto(val);
            showSnackbar('Contacto associado com sucesso');
            formik.resetForm();
            setExpand(false);
        }
        catch (error) {
            showSnackbar(`Ocorreu um erro ao associar contacto`);
        }
        fetchData();
    };
    useEffect(() => {
        let active = true;
        const test = async () => {
            if (inputValue === '') {
                setOptions([]);
                return;
            }
            setLoading(true);
            try {
                let data = await CrmService.lookupContacto(inputValue);
                if (active) {
                    setOptions(data);
                }
            }
            catch (e) {
                console.error(e);
            }
            finally {
                if (active)
                    setLoading(false);
            }
        };
        test();
        return () => {
            active = false;
        };
    }, [inputValue]);
    // Filtragem dentro de cada coluna
    // Modo de filtro (igual a, contém, começa com... )
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    const onCellView = (cell) => {
        $state.go('app.crm.pessoas.details', { id: cell.idCoreContactoAssociado });
    };
    const initialFetch = async () => {
        if (loadingEmpresaAssociada) {
            // opt -> vai buscar os campos filtraveis
            const opt = await CrmService.optionsPessoasAssociada();
            setOptionsEmpresaAssociada(opt);
            setLoadingEmpresaAssociada(false);
        }
    };
    const fetchData = async () => {
        try {
            let filters = {};
            filterEmpresaAssociada.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sortEmpresaAssociada.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            if (user !== undefined) {
                filters['idCoreContacto'] = `$eq:${user.id}`;
            }
            // aux vai buscar os dados consoante os filtros
            const aux = await CrmService.findAllContactosAssociados({
                limit: paginationEmpresaAssociada.pageSize,
                page: paginationEmpresaAssociada.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            // Update URL
            $state.go($state.current.name, {
                limit: paginationEmpresaAssociada.pageSize,
                page: paginationEmpresaAssociada.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filterEmpresaAssociada).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            setDataEmpresaAssociada(aux);
        }
        catch (e) {
            console.log(e);
        }
        setRefetchingEmpresaAssociada(false);
    };
    useEffect(() => {
        initialFetch();
        if (!refetchingEmpresaAssociada) {
            setRefetchingEmpresaAssociada(true);
            fetchData();
        }
    }, [paginationEmpresaAssociada, filterEmpresaAssociada, sortEmpresaAssociada]);
    return (<Box>
      <Stack direction='column'>
        <Stack direction='row' spacing={1} justifyContent='flex-start' alignItems='center'>
          <Typography variant='h6' sx={{ color: 'black' }}>
            Contactos associados 
          </Typography>
          {expand ? (<Tooltip title={'Cancelar'}>
              <IconButton color='primary' onClick={() => {
                formik.resetForm();
                setExpand(!expand);
            }}>
                <MdiIcon path={mdiChevronUp} sx={{ color: '#1976D2' }}/>
              </IconButton>
            </Tooltip>) : (<Box></Box>)}

          <Tooltip title={'Guardar dados'}>
            <IconButton color='primary' onClick={() => {
            if (expand) {
                formik.handleSubmit();
            }
            else {
                formik.resetForm();
                setOptions([]);
                setExpand(!expand);
            }
        }}>
              <MdiIcon path={!expand ? mdiPlus : mdiContentSave} sx={{ color: '#1976D2' }}></MdiIcon>
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>

      <Collapse in={expand}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Autocomplete value={value} // O valor completo da opção selecionada
     onChange={(event, newValue) => {
            setValue(newValue);
            formik.setFieldValue('idCoreContactoAssociado', newValue.id, true);
            formik.setFieldTouched('idCoreContactoAssociado', true);
        }} isOptionEqualToValue={(e, v) => {
            return e.id === v.id;
        }} inputValue={inputValue} onInputChange={(_, newInputValue) => setInputValue(newInputValue)} options={options} noOptionsText={inputValue === '' || inputValue.length < 2 ? 'Introduza um termo de pesquisa' : 'Nenhum contacto encontrado'} loadingText={'A carregar ...'} getOptionLabel={option => option.nome} loading={loading} renderOption={(props, option) => (<ListItem {...props} key={option.id} dense>
                  <ListItemText primary={option.nome}/>
                </ListItem>)} renderInput={params => (<TextField {...params} name='idCoreContactoAssociado' label='Contacto' required={true} size='small' fullWidth onBlur={formik.handleBlur} error={formik.touched.idCoreContactoAssociado && Boolean(formik.errors.idCoreContactoAssociado)} helperText={formik.touched.idCoreContactoAssociado && formik.errors.idCoreContactoAssociado} InputProps={{
                ...params.InputProps,
                endAdornment: (<>
                        {loading ? <CircularProgress color='inherit' size={20}/> : null}
                        {params.InputProps.endAdornment}
                      </>)
            }}/>)}/>
          </Grid>
        </Grid>
      </Collapse>

      <Box sx={{
            mt: 2,
            borderRadius: '15px',
            border: '1px solid #e0e0e0',
            overflow: 'hidden',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
        }}>
        <Table storageKey={$state.current.name} data={dataEmpresaAssociada} columns={[
            {
                accessorKey: 'contactoAssociado.nome',
                header: 'Contacto',
                size: 100
            },
            {
                accessorKey: 'dataRegisto',
                header: 'Data de registo',
                size: 100,
                Cell: ({ renderedCellValue }) => (renderedCellValue ? moment(renderedCellValue).format('DD/MM/YYYY') : '-')
            }
        ]} initial={{
            sort: sortEmpresaAssociada,
            filter: filterEmpresaAssociada
        }} onDoubleClick={row => {
            onCellView(row);
        }} isLoading={refetchingEmpresaAssociada} options={optionsEmpresaAssociada} onPaginate={setPaginationEmpresaAssociada} onFilter={setFilterEmpresaAssociada} onSort={setSortEmpresaAssociada}></Table>
      </Box>
    </Box>);
};
export default PessoasAssociadas;
